module.exports = __webpack_public_path__ + "assets/emoticon-2star.92910179.svg";